export const DEFAULT_DROPDOWN_TITLE = "Agent Tools";
